import React, { useCallback, useEffect, useState, useRef } from "react";
import { CiSearch } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import LeftSideAnimation from "../../components/animations/LeftAndRightSideAnimation";
import Header from "../../components/header/Header";
import {
  useFetchConversationQuery,
  useFetchProfilesQuery,
  useSendMessageMutation,
} from "../../store/api/apiSlice";

const Chat = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");

  const [selectedUserDiv, setSelectedUserDiv] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [userList, setUserList] = useState(null);
  const [isUserListLoading, setIsUserListLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_SERVER_URL;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const otherUserId = queryParams.get("userId");
  const userName = queryParams.get("name");

  const { data: profileData, isLoading: isProfileLoading } =
    useFetchProfilesQuery();
  const { data: receiverProfile } = useFetchProfilesQuery(otherUserId, {
    skip: !otherUserId,
  });
  const [sendMessage] = useSendMessageMutation();
  const chatContainerRef = useRef(null);

  const fetchUserList = useCallback(async () => {
    const userId = profileData?.user?._id || profileData?._id;
    if (!userId || userList) return;

    setIsUserListLoading(true);

    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": process.env.REACT_APP_SECRET_KEY || "",
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/messages/user-msglist?userId=${userId}`,
        { headers }
      );
      if (!response.ok) throw new Error("Failed to load user list");

      const data = await response.json();
      setUserList(data);
    } catch (error) {
      toast.error("Failed to load users.");
    } finally {
      setIsUserListLoading(false);
    }
  }, [profileData, userList]);
  const [profile, setProfile] = useState({
    image: "image",
    avatarName: "avatarName",
  });
  useEffect(() => {
    if (profileData) {
      setProfile({
        image: profileData.user.image,
        avatarName: profileData.user.avatarName,
      });
    }
  }, [profileData]);
  useEffect(() => {
    if (profileData?.user?._id && !userList) {
      fetchUserList();
    }
  }, [profileData, userList, fetchUserList]);

  useEffect(() => {}, [userList]);
  const { data: conversation, refetch: refetchConversation } =
    useFetchConversationQuery(
      {
        userId: profileData?.user?._id,
        otherId: selectedUser?._id || otherUserId,
      },
      { skip: !(selectedUser || otherUserId) }
    );

  const filteredUserList = searchInputValue
    ? userList?.contacts?.filter((user) =>
        `${user.firstName} ${user.lastName}`
          .toLowerCase()
          .includes(searchInputValue.toLowerCase())
      )
    : userList?.contacts;

  useEffect(() => {
    if (otherUserId && userList) {
      const user = userList.contacts.find((u) => u._id === otherUserId);
      if (user) {
        setSelectedUser(user);
      } else if (receiverProfile) {
        setSelectedUser(receiverProfile);
      }
    }
  }, [otherUserId, userList, receiverProfile]);

  const handleSendMessage = async () => {
    if (!message.trim() || !(selectedUser || otherUserId)) return;

    try {
      const newMessage = {
        userId: profileData?.user?._id,
        forumId: "Nill",
        receiverId: selectedUser?._id || otherUserId, // Use otherUserId if selectedUser is null
        message,
        messageType: "text",
        type: "private",
        status: true,
      };
      const response = await sendMessage(newMessage).unwrap();
      if (response.message === "Message Created Successfully") {
        setMessage("");
        refetchConversation();
        fetchUserList();
      }
    } catch (error) {
      // console.error("Error sending message:", error);
      toast.error("Failed to send message.");
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);

    if (windowWidth < 768) {
      setSelectedUserDiv(false);
    }
    if (conversation) {
      refetchConversation();
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [conversation?.messages]);
  if (isProfileLoading || isUserListLoading) return <p>Loading users...</p>;

  return (
    <>
      <Header />
      <section className="Messaging_container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="bg-white">
                <div className="heading_box">
                  <FadeInAnimation>
                    <h4 className="froumtitle Messaging_mobile">Messaging</h4>
                  </FadeInAnimation>
                </div>
                <div id="chat">
                  <div className="row align-items-start">
                    {selectedUserDiv ? (
                      <div className="col-lg-4 col-md-5 pb-4 px-3 px-md-4 outerContainerChatUsers">
                        <div className="mt-4 outerWrapperLeftSideOfChat card">
                          <div className="p-3">
                            <div className="position-relative">
                              <CiSearch className="SearchIcon" />
                              <input
                                type="text"
                                className="Search"
                                placeholder="Search Contact"
                                value={searchInputValue}
                                onChange={(e) =>
                                  setSearchInputValue(e.target.value)
                                }
                              />
                            </div>
                            <div className="outerWrapperChatUserList">
                              {filteredUserList?.map((user, index) => (
                                <div
                                  key={index}
                                  className={`sidebarchat mt-2 d-flex gap-2 align-items-start ${
                                    selectedUser?._id === user._id
                                      ? "selectedUser"
                                      : "HoverChatUser"
                                  }`}
                                  onClick={() => handleUserClick(user)}
                                >
                                  <FadeInAnimation>
                                    <img
                                      src={
                                        user.image && user.image.trim() !== ""
                                          ? `${baseUrl}/${user.image}`
                                          : "/images/default-user.png"
                                      }
                                      className="rounded-circle imageInChatList"
                                      alt={user?.avatarName}
                                    />
                                  </FadeInAnimation>
                                  <div className="d-flex justify-content-between w-100">
                                    <div>
                                      <FadeInAnimation>
                                        <h3
                                          className={`senderanem TextColorWhite userHeadingInChatList ${
                                            selectedUser?._id === user._id
                                              ? "text-black"
                                              : ""
                                          }`}
                                        >
                                          {user.firstName} {user.lastName}
                                        </h3>
                                      </FadeInAnimation>
                                      <FadeInAnimation>
                                        <p
                                          className={`TextColorWhite2 textmessgae smallMessageInChatUser ${
                                            selectedUser?._id === user._id
                                              ? "text-black"
                                              : ""
                                          }`}
                                        >
                                          {user.message}
                                        </p>
                                      </FadeInAnimation>
                                    </div>
                                    {user.messageCount && (
                                      <FadeInAnimation>
                                        <span className="badge green mx-3">
                                          {user.messageCount}
                                        </span>
                                      </FadeInAnimation>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-lg-8 col-md-7 py-4 px-3 px-md-4">
                      <div className="outerContainerChatBox card">
                        <div className="messageboxheight">
                          <div
                            className="chatContainer"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            {selectedUser ? (
                              <div className="HeaderInChatBox d-flex p-3 gap-2 align-items-center mb-4">
                                <FadeInAnimation>
                                  <img
                                    // src={selectedUser?.user?.image || "/images/chat-1.png"}
                                    src={
                                      selectedUser?.image &&
                                      selectedUser?.image.trim() !== ""
                                        ? `${baseUrl}/${selectedUser?.image}`
                                        : "/images/default-user.png"
                                    }
                                    alt={selectedUser?.avatarName}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </FadeInAnimation>
                                {/* <FadeInAnimation> */}
                                <h3 className="UserHeadingInChatHeader">
                                  {selectedUser.firstName || userName}{" "}
                                  {selectedUser.lastName || ""}
                                </h3>

                                {/* </FadeInAnimation> */}
                              </div>
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <p>Select a user to start chatting</p>
                              </div>
                            )}

                            <div
                              className="MessagingList mt-2"
                              style={{
                                flex: 1,
                                overflowY: "auto",
                                padding: "15px",
                              }}
                              ref={chatContainerRef}
                            >
                              {selectedUser &&
                                conversation?.messages?.map((msg, index) => (
                                  <div
                                    key={index}
                                    className={`chatboxinneritem ${
                                      msg.senderID === profileData?.user._id
                                        ? "userMessage"
                                        : "receivedMessage"
                                    }`}
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      marginBottom: "15px",
                                      justifyContent:
                                        msg.senderID === profileData?.user._id
                                          ? "flex-end"
                                          : "flex-start",
                                    }}
                                  >
                                    {msg.senderID === profileData?.user._id ? (
                                      <FadeInAnimation>
                                        <img
                                          src={`${baseUrl}/${profile.image}`}
                                          alt={profile.avatarName}
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            marginRight: "10px",
                                          }}
                                        />
                                      </FadeInAnimation>
                                    ) : (
                                      <FadeInAnimation>
                                        <img
                                          src={`${baseUrl}/${
                                            selectedUser?.image ||
                                            "/images/default-user.png"
                                          }`} 
                                          alt={selectedUser?.avatarName}
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            marginRight: "10px",
                                          }}
                                        />
                                      </FadeInAnimation>
                                    )}
                                    <div
                                      style={{
                                        maxWidth: "70%",
                                        backgroundColor:
                                          msg.senderID === profileData?.user._id
                                            ? "#d1e7dd"
                                            : "#f1f3f5",
                                        borderRadius: "20px",
                                        padding: "10px 15px",
                                        position: "relative",
                                      }}
                                    >
                                      <h4
                                        className="senderanem"
                                        style={{
                                          fontSize: "0.9rem",
                                          fontWeight: "bold",
                                          color:
                                            msg.senderID ===
                                            profileData?.user._id
                                              ? "#155724"
                                              : "#333",
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {msg.senderID === profileData?.user._id
                                          ? "You"
                                          : `${msg.sender?.firstName || ""} ${
                                              msg.sender?.lastName || ""
                                            }`}
                                        <span
                                          style={{
                                            fontSize: "0.8rem",
                                            color: "#777",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          {new Date(
                                            msg.sentAt
                                          ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                          })}
                                        </span>
                                      </h4>
                                      <p style={{ margin: 0, color: "#333" }}>
                                        {msg.content}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>

                        <div className="message-input-container">
                          <LeftSideAnimation x={100}>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control message-input"
                                placeholder="Send a message..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                onKeyPress={(e) =>
                                  e.key === "Enter" && handleSendMessage()
                                }
                                disabled={!(selectedUser || otherUserId)}
                              />
                              <button
                                className="btn btn-primary px-3"
                                type="button"
                                onClick={handleSendMessage}
                                disabled={
                                  !(selectedUser || otherUserId) ||
                                  !message.trim()
                                }
                              >
                                SEND
                              </button>
                            </div>
                          </LeftSideAnimation>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Chat;
